/* eslint-disable react/jsx-key */
import React from 'react'

import Checkbox from '../Checkbox'

class MemberTypes extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // allMembersData: this
    }
  }

  handleMembersData = rowItem => {
    const rowItemNew = { ...rowItem }
    const { returnSelectedId, selectedData } = this.props
    const selectedIndex = (selectedData || []).findIndex(item => item.id === rowItemNew.id)
    if (selectedIndex === -1 && rowItemNew.action === '') {
      rowItemNew.action = 'add'
      selectedData.push(rowItemNew)
    } else if (selectedIndex !== -1 && selectedData[selectedIndex].action === 'add') {
      selectedData.splice(selectedIndex, 1)
    } else if (selectedIndex !== -1 && selectedData[selectedIndex].action === '') {
      selectedData[selectedIndex].action = 'delete'
    } else if (selectedIndex !== -1 && selectedData[selectedIndex].action === 'delete') {
      selectedData[selectedIndex].action = ''
    }
    returnSelectedId(selectedData)
  }

  render() {
    const { allMembersData, selectedData, isEdit } = this.props
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}
      >
        {allMembersData.length > 0 &&
          allMembersData.map(item => (
            // biome-ignore lint/correctness/useJsxKeyInIterable: TODO
            <span style={{ marginRight: '10px' }}>
              <Checkbox
                label={item.type}
                isDisabled={isEdit}
                isChecked={
                  (selectedData || []).findIndex(
                    itemInner => itemInner.id === item.id && itemInner.action !== 'delete'
                  ) !== -1
                }
                onChange={() => {
                  this.handleMembersData(item)
                }}
                labelPlacement="right"
              />
            </span>
          ))}
      </div>
    )
  }
}

MemberTypes.defaultProps = {
  allMembersData: [],
  selectedData: [],
  isEdit: false,
}

export default MemberTypes
